import React, { useContext } from 'react'
import FormLabel from './form-label'
import { FormContext } from '../form'
import { withNullErrorBoundary } from '../../utils'

const FormRadioOption = ({ checked, onChange, ...props }) => {
  const { state, setState } = useContext(FormContext)
  const isChecked = checked !== undefined ? checked : state[props.groupName] === props.value
  const setValue = () => {
    if (typeof onChange === 'function') {
      onChange(props.value)
    }

    setState({ [props.groupName]: props.value })
  }

  return (
    <div className="form-check">
      <input checked={isChecked} onChange={() => setValue()} type="radio" name={props.groupName} value={props.value} id={`form-input-${props.uniqueName}`} className={`${props.className}-input`} />
      <FormLabel className={`${props.className}-label`} for={`${props.uniqueName}`} title={props.title || props.value} />
    </div>
  )
}

export default withNullErrorBoundary(FormRadioOption)
